export default {"src":"/_next/static/image/src/components/ComparisonChart/check-icon.8e27ab66d08502a2e1675d1ef2c2478c.svg","height":35,"width":35};